import React from 'react';
import styles from './Training.module.scss';
import { imageBasePath } from 'constants';
import { CustomButton } from 'shared_ui_components';
import { TooltipCustom } from 'utils';
const GenerateQuizCard = ({
  image = '',
  title = '',
  subTitle = '',
  actionButton = '',
  onClick = null,
  comingSoon = false,
  disabled = false,
}) => {
  return (
    <>
      {disabled ? (
        <TooltipCustom
          placement="top"
          arrow
          title={
            <div className="supportText" style={{ color: `#fff` }}>
              AI wont be able to generate questions as content refers to content outside our
              platform.
            </div>
          }
        >
          <div className={styles.cardContainer}>
            <div className={styles.cardImageContainer}>
              <img src={imageBasePath + image} alt={''} className={styles.cardImage} />
            </div>
            <span className="heading4">{title}</span>
            <span className={`supportText ${styles.cardSubTitle}`}>{subTitle}</span>
            <CustomButton
              disabled={disabled}
              className={'primaryBtn'}
              onClick={onClick}
            >
              {actionButton}
            </CustomButton>{' '}
            {/* {comingSoon && <div className={styles.comingSoon}>Coming soon</div>} */}
          </div>
        </TooltipCustom>
      ) : (
        <>
          <div className={styles.cardContainer}>
            <div className={styles.cardImageContainer}>
              <img src={imageBasePath + image} alt={''} className={styles.cardImage} />
            </div>
            <span className="heading4">{title}</span>
            <span className={`supportText ${styles.cardSubTitle}`}>{subTitle}</span>
            <CustomButton
              disabled={comingSoon || disabled}
              className={comingSoon ? 'primaryBtn disabledBtn' : 'primaryBtn'}
              onClick={onClick}
            >
              {actionButton}
            </CustomButton>{' '}
            {comingSoon && <div className={styles.comingSoon}>Coming soon</div>}
          </div>
        </>
      )}
    </>
  );
};

export default GenerateQuizCard;
